const deviceGroup = {
  namespaced: true,
  state: {
    deviceGroupList: [],
  },
  mutations: {
    updateDeviceGroupList(state, newList) {
      state.deviceGroupList = newList
    },
  },
  actions: {
    getDeviceGroupList(context) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get('/traveller/restui/device-groups/') 
          .then(function (response) {
            context.commit('updateDeviceGroupList', response.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    saveParametersForDisplayGroup(context, groupParameters) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .post('/traveller/restui/ssedisplay/saveParametersForDisplayGroup', groupParameters) 
          .then(function (response) {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    sendAnnouncementsToGroup(context, id) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .post(`/traveller/restui/device-groups/${id}/send-announcements`)
          .then(function (response) {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    addDeviceGroup(context, newDeviceGroup) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .post('/traveller/restui/device-groups/', newDeviceGroup)
          .then((response) => {
            context.dispatch('getDeviceGroupList')
            resolve(response)
          })
          .catch((error) => {
            context.dispatch('getDeviceGroupList')
            reject(error)
          })
      })
    },
    updateDeviceGroup(context, updatedDeviceGroup) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .put(
            `/traveller/restui/device-groups/${updatedDeviceGroup.id}`,
            updatedDeviceGroup
          )
          .then((response) => {
            context.dispatch('getDeviceGroupList')
            resolve(response)
          })
          .catch((error) => {
            context.dispatch('getDeviceGroupList')
            reject(error)
          })
      })
    },
    removeDeviceGroup(context, deviceGroupId) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .delete(`/traveller/restui/device-groups/${deviceGroupId}`)
          .then((response) => {
            context.dispatch('getDeviceGroupList')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },
}

export default deviceGroup
